import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SEARCH_PARAMS } from '@/const/searchParams';

export interface SearchFilters {
    query: string;
    projectId: string;
    agentId: string;
    flowId: string;
}

export const useSearchFilters = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const filters: SearchFilters = {
        query: searchParams.get(SEARCH_PARAMS.QUERY) ?? '',
        projectId: searchParams.get(SEARCH_PARAMS.PROJECT_ID) ?? '',
        agentId: searchParams.get(SEARCH_PARAMS.AGENT_ID) ?? '',
        flowId: searchParams.get(SEARCH_PARAMS.FLOW_ID) ?? ''
    };

    const updateParam = useCallback(
        (
            key: string,
            value: string | null | undefined,
            clearDependents?: string[]
        ) => {
            setSearchParams(
                (currentParams) => {
                    const newParams = new URLSearchParams(currentParams);

                    if (value) {
                        newParams.set(key, value);
                    } else {
                        newParams.delete(key);
                    }

                    clearDependents?.forEach((dep) => {
                        newParams.delete(dep);
                    });

                    return newParams;
                },
                { replace: true }
            );
        },
        [setSearchParams]
    );

    return { filters, updateParam };
};
